import styled from 'styled-components';
import { NoneButton } from '../AttachmentTag/AttachmentTag';

export const StyledDropdown = styled.div<{
  inline?: boolean;
  maxDropdownHeight?: number;
}>`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  width: 100%;
  min-width: 10rem;
  padding: 0;
  margin: 8px 0 0;
  text-align: left;
  list-style: none;
  background-color: ${({ theme }) => theme.colors.white};
  background-clip: padding-box;
  border: 1px solid #a5a5a5;
  border-radius: 4px;
  ${({ inline }) =>
    inline &&
    `
       box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
  border: unset;
  border-radius: 4px;
  margin: unset;
    `};
  max-height: ${({ maxDropdownHeight }) =>
    maxDropdownHeight ? `${maxDropdownHeight}px` : 'auto'};
  overflow-y: auto;
`;

export const StyledDropdownItem = styled(NoneButton)`
  display: block;
  width: 100%;
  height: 20px;
  padding: 4px 16px;
  clear: both;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  &:first-child,
  &:last-child {
    margin-top: 0;
  }
  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colors.background2};
  }
`;

export const StyledDropdownPlaceholder = styled.div`
  color: #a5a5a5;
`;

export const StyledDropdownSelection = styled.div`
  width: 100%;
  padding-right: 25px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
